import { useMemo } from "react";

import { translate } from "app/filters/i18nFilter";
import { SIBreadcrumbs } from "app/pages/sales-intelligence/common-components/SIBreadcrumbs/SIBreadcrumbs";
import { MANAGEMENT_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import { EXPORT_INTEGRATION_ROUTE, MANAGE_INTEGRATION_ROUTE } from "app/pages/sales-intelligence/constants/sl_routes";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import {
    BREADCRUMB_EXPORT_FIELD_MAPPING,
    BREADCRUMB_INTEGRATIONS,
    BREADCRUMB_MANAGE_INTEGRATION,
} from "app/pages/sales-intelligence/common-components/export-table/translations";

type ManageExportBreadcrumbsProps = {
    integrationName: Integration;
};

export const ManageExportBreadcrumbs = ({ integrationName }: ManageExportBreadcrumbsProps) => {
    const breadcrumbs = useMemo(
        () => [
            {
                state: MANAGEMENT_ROUTE,
                title: translate(BREADCRUMB_INTEGRATIONS),
            },
            {
                state: MANAGE_INTEGRATION_ROUTE[integrationName],
                title: translate(BREADCRUMB_MANAGE_INTEGRATION[integrationName]),
            },
            {
                state: EXPORT_INTEGRATION_ROUTE[integrationName],
                title: translate(BREADCRUMB_EXPORT_FIELD_MAPPING),
            },
        ],
        [integrationName],
    );

    const handleBreadcrumbClick = ({ state }: { state: string }): void => {
        void proNavigator.go(state);
    };

    return (
        <SIBreadcrumbs
            list={breadcrumbs}
            onClick={handleBreadcrumbClick}
            dataAutomation="manage-export-breadcrumbs"
        />
    );
};
